/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Select_PromptInputs */

const en_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a shortcut from the menu to start`)
};

const fr_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un raccourci dans le menu pour commencer`)
};

const de_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie im Menü eine Verknüpfung zum Starten aus.`)
};

const it_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una scorciatoia dal menu per iniziare`)
};

const ru_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите ярлык из меню, чтобы начать.`)
};

const es_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un acceso directo del menú para comenzar.`)
};

const zh_cn2_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从菜单中选择快捷方式开始`)
};

const ja_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するにはメニューからショートカットを選択してください`)
};

const hi_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू करने के लिए कृपया मेनू से एक शॉर्टकट चुनें।`)
};

const pt_pt2_shortcut_keys_select_prompt = /** @type {(inputs: Shortcut_Keys_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um atalho no menu para iniciar.`)
};

/**
* | output |
* | --- |
* | "Please select a shortcut from the menu to start" |
*
* @param {Shortcut_Keys_Select_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_select_prompt = /** @type {((inputs?: Shortcut_Keys_Select_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Select_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_select_prompt(inputs)
	if (locale === "de") return de_shortcut_keys_select_prompt(inputs)
	if (locale === "it") return it_shortcut_keys_select_prompt(inputs)
	if (locale === "ru") return ru_shortcut_keys_select_prompt(inputs)
	if (locale === "es") return es_shortcut_keys_select_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_select_prompt(inputs)
	if (locale === "ja") return ja_shortcut_keys_select_prompt(inputs)
	if (locale === "hi") return hi_shortcut_keys_select_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_select_prompt(inputs)
	return en_shortcut_keys_select_prompt(inputs)
});